/* eslint no-undef: 'off' */
import $, { ajax } from "jquery"; // eslint-disable-line


const IDSEARCH = '#dgwt-wcas-search-input-1';

/**
 * run all functions
 */
const init = () => {
    run();
}

/**
 * get data input
 */
const run = () => {
    $(document).on('change', IDSEARCH, function(e){ // eslint-disable-line
        let string_input = $(this).val();
        const param = parameters.ajax_search_log;

        let data = {
            string_input : string_input,
            nonce        : parameters.nonceFE,
            action       : param.action,
        }
        
        $.ajax({
            type      : 'POST', 
            data      : data,
            url       : parameters.url_admin_ajax,
            dataType  : 'json'
        }).done(function (response) {// eslint-disable-line 
        });
        
    });
}

init();